import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

export default function HeroStyle5({ highlightTitle, title, subTitle }) {
  const stats = [
    { icon: "mdi:cube-outline", number: "50+", label: "Projects Delivered" },
    {
      icon: "mdi:emoticon-happy-outline",
      number: "98%",
      label: "Client Satisfaction",
    },
    {
      icon: "mdi:clock-outline",
      number: "24/7",
      label: "Ongoing Support",
    },
    { icon: "mdi:account-group-outline", number: "10+", label: "Tech Experts" },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-gray-50 via-white to-gray-50 pt-[116px] sm:pt-[128px] lg:pt-[140px] pb-8 sm:pb-12 lg:pb-[60px]">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Top-left curved lines */}
        <svg
          className="absolute top-0 left-0 w-[400px] h-[400px] opacity-[0.07]"
          viewBox="0 0 400 400"
          fill="none"
        >
          <circle cx="0" cy="0" r="150" stroke="#1b667a" strokeWidth="1.5" />
          <circle cx="0" cy="0" r="220" stroke="#1b667a" strokeWidth="1" />
          <circle cx="0" cy="0" r="290" stroke="#1b667a" strokeWidth="0.5" />
        </svg>

 
         

 

        {/* Left gradient blob */}
        <div className="absolute top-[30%] left-[-80px] w-[300px] h-[300px] rounded-full bg-gradient-to-br from-brand-orange/5 to-brand-teal/5 blur-3xl" />
        <div className="absolute bottom-[30%] right-[20%] w-1 h-1 rounded-full bg-brand-teal/20" />
      </div>

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 w-full relative z-10">
        <div className="relative text-center">
          {/* Title */}
          <h1
            className="text-[52px] leading-[1.15] font-bold text-gray-900 mb-6 max-w-[900px] mx-auto
            max-[1400px]:text-[60px]
            max-[1199px]:text-[52px]
            max-[991px]:text-[40px]
            max-[380px]:text-[32px]"
          >
            Your Vision.
            <br />
            Engineered to{" "}
            <span className="bg-gradient-to-r from-[#15566a] via-[#1b667a] to-[#3aa6a0] bg-clip-text text-transparent">
              Perfection.
            </span>
          </h1>

          {/* Green accent line */}
          <div className="w-[50px] h-[4px] rounded-full bg-gradient-to-r from-brand-teal to-brand-teal/60 mx-auto mb-6" />

          {/* Subtitle */}
          <p className="text-gray-500 mb-10 max-w-[680px] mx-auto leading-relaxed text-[16px]">
            {subTitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-10 sm:mb-16 px-4 sm:px-0">
            <Link to="/contact" className="w-full sm:w-auto">
              <button className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#1b667a] text-white px-7 py-3.5 rounded-xl text-[15px] font-medium hover:bg-[#155568] transition-all duration-300 hover:-translate-y-0.5 shadow-[0_8px_22px_rgba(27,102,122,0.22)] hover:shadow-[0_10px_28px_rgba(27,102,122,0.3)]">
                Get Started
                <Icon
                  icon="mdi:arrow-right"
                  className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1"
                />
              </button>
            </Link>
            <Link to="/service" className="w-full sm:w-auto">
              <button className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white text-gray-700 px-7 py-3.5 rounded-xl text-[15px] font-medium hover:bg-brand-teal/10 hover:text-brand-teal transition-all duration-300 hover:-translate-y-0.5 shadow-sm hover:shadow-md border border-gray-100 sm:border-0">
                Explore Services
                <Icon
                  icon="mdi:arrow-right"
                  className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1"
                />
              </button>
            </Link>
          </div>
        </div>

        {/* Floating Feature Cards */}
        {/* Left card - Clean Code */}
        <div className="hidden lg:block absolute left-[-10px] top-[38%] z-20">
          <div className="bg-white rounded-2xl p-5 shadow-[0_4px_24px_rgba(0,0,0,0.06)] max-w-[200px]">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 rounded-full bg-green-500" />
              <span className="text-[13px] font-semibold text-gray-900">
                Clean Code
              </span>
            </div>
            <p className="text-[11px] text-gray-400 leading-relaxed">
              Maintainable solutions built for the future.
            </p>
          </div>
        </div>

        {/* Left decorative shape */}
        <div className="hidden lg:block absolute left-[4%] bottom-[20%] z-10">
          <div className="relative w-[160px] h-[160px]">
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-brand-teal/10 to-green-500/5 rotate-12" />
            <div className="absolute inset-3 rounded-2xl bg-gradient-to-tr from-brand-teal/15 to-blue-500/5 -rotate-6 flex items-center justify-center">
              <Icon
                icon="mdi:code-braces"
                className="w-10 h-10 text-brand-teal/30"
              />
            </div>
          </div>
        </div>

        {/* Right card - AI-Powered */}
        <div className="hidden lg:block absolute right-[-10px] top-[34%] z-20">
          <div className="bg-white rounded-2xl p-5 shadow-[0_4px_24px_rgba(0,0,0,0.06)] max-w-[200px]">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 rounded-full bg-blue-500" />
              <span className="text-[13px] font-semibold text-gray-900">
                AI-Powered
              </span>
            </div>
            <p className="text-[11px] text-gray-400 leading-relaxed">
              Intelligent systems that drive impact.
            </p>
          </div>
        </div>

        {/* Right decorative shape */}
        <div className="hidden lg:block absolute right-[4%] bottom-[22%] z-10">
          <div className="relative w-[140px] h-[140px]">
            <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-500/10 to-brand-teal/5" />
            <div className="absolute inset-4 rounded-full bg-gradient-to-tr from-brand-orange/8 to-blue-500/5 flex items-center justify-center">
              <Icon icon="mdi:brain" className="w-9 h-9 text-blue-400/25" />
            </div>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-6 sm:mt-8 px-2 sm:px-0">
          <div className="bg-white/80 backdrop-blur-lg rounded-2xl border border-gray-100 shadow-[0_8px_40px_rgba(0,0,0,0.06)] max-w-[800px] mx-auto overflow-hidden">
            <div className="grid grid-cols-2 md:grid-cols-4">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className={`flex items-center gap-2 sm:gap-3 px-4 sm:px-6 py-4 sm:py-5 border-gray-100 ${
                    index % 2 === 0 ? "border-r" : "max-[767px]:border-r-0"
                  } ${index !== stats.length - 1 ? "md:border-r" : "md:border-r-0"} ${
                    index >= 2 ? "border-t md:border-t-0" : ""
                  }`}
                >
                  <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-brand-teal/[0.08] flex items-center justify-center flex-shrink-0">
                    <Icon
                      icon={stat.icon}
                      className="w-4 h-4 sm:w-5 sm:h-5 text-brand-teal"
                    />
                  </div>
                  <div className="min-w-0">
                    <div className="text-[18px] sm:text-[22px] font-bold text-gray-900 leading-tight">
                      {stat.number}
                    </div>
                    <div className="text-[11px] sm:text-[12px] text-gray-500 leading-tight">
                      {stat.label}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Scroll indicator
        <div className="text-center mt-10">
          <div className="inline-flex flex-col items-center gap-2 text-gray-400">
            <div className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center animate-bounce">
              <Icon icon="mdi:chevron-down" className="w-5 h-5" />
            </div>
            <span className="text-[12px]">Scroll to explore</span>
          </div>
        </div> */}
      </div>
    </section>
  );
}
